<template>
  <div class="p-the-page-l04 c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <TheHeader ref="theHeader" />
      <div class="c-common-inner">
        <TheBreadcrumb />
        <div class="p-the-page-l04__inner">
          <TheL04Header
            v-if="whatsNewDetailsModel"
            :title="title"
            :published-at="publishedAt"
            :updated-at="updatedAt"
            :author-name="authorName"
            :author-id="authorId"
          />
          <TextSanitized
            :text="content"
            class="p-the-page-l04__content adjust-head-size adjust-body-text-size"
          />
          <TheL04Pagination :prev-news="prevNews" :next-news="nextNews" />
        </div>
      </div>
    </div>
    <theFooter />
  </div>
</template>

<script lang="ts">
import TextSanitized from "@/common/components/atoms/TextSanitized.vue";
import TheL04Header from "@/general/components/pages/parts/WhatsNewDetails/TheL04Header.vue";
import TheL04Pagination from "@/general/components/pages/parts/WhatsNewDetails/TheL04Pagination.vue";
import { Options, Vue } from "vue-class-component";
import store from "@/general/store";
import { WhatsNewDetailsModel } from "@/general/store/models";
import { getWhatsNewDetails } from "@/general/store/api";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import CONST_DATA from "@/general/mixins/const/constData";
import AuthStorage from "@/general/utils/auth";

@Options({
  name: "WhatsNewDetails",
  components: {
    TextSanitized,
    TheL04Header,
    TheL04Pagination
  },
  store: store
})
export default class WhatsNewDetails extends Vue {
  whatsNewDetailsModel?: WhatsNewDetailsModel;
  title: string | undefined | null = "";
  content: string | undefined | null = "";
  publishedAt = "";
  updatedAt = "";
  authorName = "";
  authorId = "";
  pk: number | undefined = 0;
  prevNews: any = {
    title: "",
    link: ""
  };
  nextNews: any = {
    title: "",
    link: ""
  };

  breadcrumb = [
    {
      text: "",
      url: CONST_DATA.SITE_MAP.TOP_PAGE,
      pageType: "home"
    },
    {
      text: "お知らせ一覧",
      url: CONST_DATA.SITE_MAP.WHATS_NEW,
      pageType: "lower"
    },
    {
      text: "お知らせ詳細",
      url: "",
      pageType: "lower"
    }
  ];

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }


  get urlWhatsNewDetail() {
    return CONST_DATA.SITE_MAP.WHATS_NEW_DETAILS;
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    await commons.getBreadcrumb(this.breadcrumb);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const id = parseInt(urlParams.get("id") as string);
    await this.whatsNewDetails(id);
  }

  async whatsNewDetails(id: number) {
    const response = await getWhatsNewDetails(id);
    if (!response?.title) {
      window.location.href = "/error-not-found";
      return false;
    }
    this.whatsNewDetailsModel = response;

    if (this.whatsNewDetailsModel) {
      this.title = this.whatsNewDetailsModel.title;
      this.publishedAt = this.$dayjs
        .utc(this.whatsNewDetailsModel.created_at)
        .locale("ja")
        .format("YYYY/MM/DD");
      this.updatedAt = this.$dayjs
        .utc(this.whatsNewDetailsModel.updated_at)
        .locale("ja")
        .format("YYYY/MM/DD");
      this.authorName = this.whatsNewDetailsModel.author_name;
      this.authorId = this.whatsNewDetailsModel.employeeId;
      this.content = this.whatsNewDetailsModel.message;

      this.prevNews.link = `${this.urlWhatsNewDetail}?id=${this.whatsNewDetailsModel.page_details.previous?.url}`;
      this.prevNews.title = this.whatsNewDetailsModel.page_details.previous?.title;
      this.nextNews.link = `${this.urlWhatsNewDetail}?id=${this.whatsNewDetailsModel.page_details.next?.url}`;
      this.nextNews.title = this.whatsNewDetailsModel.page_details.next?.title;
    }
  }
}
</script>

<style lang="scss">
.p-the-page-l04 {
  &__content {
    p {
      line-height: rem(32);
    }
    ol li {
      list-style: decimal !important;
      list-style-position: inside !important;
      margin-left: 16px;
      padding: 8px;
    }
    ul li {
      list-style: disc !important;
      list-style-position: inside !important;
      margin-left: 16px;
      padding: 8px;
    }
    em * {
      font-style: italic;
    }
    i * {
      font-style: italic;
    }
  }
}
.adjust-body-text-size > a,
.adjust-body-text-size > u,
.adjust-body-text-size > i,
.adjust-body-text-size > span,
.adjust-body-text-size > p,
.adjust-body-text-size > li {
  line-height: 2rem;
  font-size: 14px; /* ICのデフォルトフォントサイズ */
}
.adjust-body-text-size blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
  line-height: 2rem;
}
.adjust-body-text-size ol,
.adjust-body-text-size ul {
  line-height: 2rem;
  margin-bottom: 1rem;
}
.adjust-body-text-size pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 12.25px;
  font-family: monospace;
  line-height: 2rem;
}
/* ヘッダテキスト行のスタイルを管理ページに合わせて設定 */
.adjust-head-size h1 {
  font-size: 2.5rem;
}
.adjust-head-size h2 {
  font-size: 2rem;
}
.adjust-head-size h3 {
  font-size: 1.75rem;
}
.adjust-head-size h4 {
  font-size: 1.5rem;
}
.adjust-head-size h5 {
  font-size: 1.25rem;
}
.adjust-head-size h6 {
  font-size: 1rem;
}
.adjust-head-size h1,
.adjust-head-size h2,
.adjust-head-size h3,
.adjust-head-size h4,
.adjust-head-size h5,
.adjust-head-size h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}
</style>
<style lang="scss" scoped>
.p-the-page-l04 {
  &__inner {
    padding: rem(32) 0 rem(56);
    margin: 0 auto;
    margin: 0 rem(128);
    word-break: break-all;
    @include sp {
      padding: rem(16) 0 rem(48);
      margin: 0 rem(48);
    }
  }

  &__content {
    margin-top: rem(24);

    @include sp {
      margin-top: rem(8);
    }
  }
}
</style>
